module.exports = __webpack_public_path__ + "img/Physician - Green - Selected.11f2515e.png";